import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class VideoComponent extends BaseComponent {
    events() {
        return {
            '.youtube-poster-action': {
                click: () => {
                    const posterContainer = this.element.querySelector('.has-poster');
                    posterContainer.classList.add('poster-clicked');

                    const iframe = this.element.querySelector('iframe');
                    iframe.contentWindow.postMessage(
                        JSON.stringify({
                            event: 'command',
                            func: 'playVideo',
                            args: [],
                        }),
                        '*',
                    );
                },
            },
        };
    }
}

defineComponent('video-component', VideoComponent);
